export enum ProjectOwnerEnum {
  User = 'USER',
  Organization = 'ORGANIZATION',
  Global = 'GLOBAL',
}
